import React, { useEffect, useRef, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { TiArrowSortedUp } from "react-icons/ti";
import Moment from "react-moment";

const TableListDynamic = ({data, heading, date, size}) => {
    const [loadAll,setLoadAll] = useState(false);
    const [dataBody,setDataBody] = useState([]);
    const [dataHead,setDataHead] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const componentRef = useRef();
  
    const getReport= (e)=>{
      componentRef.current.handleDownload();
    }
    const handleLoad = () =>{
        setDataHead(data[0] ? Object.keys(data[0]) : [])
        if(loadAll === true){
          setTableLoading(true);
          setDataBody(data);
          setTimeout(() => {    
            setTableLoading(false);
          }, 300);
        }else{
          setTableLoading(true);
          Array.isArray(data) && setDataBody(data.slice(0, 5));
          setTimeout(() => {    
            setTableLoading(false);
          }, 300);
        }
      }
     
    useEffect(()=>{
        if(data){
            handleLoad()
        }
    },[loadAll,data]);

    return (
        <div className={`col mt-3 px-2 mt-1 position-relative ${size}`}>
            <div className="dashboard__card_list">
            <ReactHTMLTableToExcel
                id="table-xls-button"
                className="download-table-xls-button btn btn-success float-right mr-3 invisible"
                table={heading}
                filename={heading}
                sheet="sheet 1"
                buttonText="Download XLS"
                ref={componentRef}
            />
            <div className="row mb-2 pr-2">
                <div className="list-heading font-weight-bold col-6">
                    <h5 className="mt-1">{heading}</h5>
                </div>
                <div className="col-6 d-flex align-items-center justify-content-end p-0">
            
                {data && data?.length > 5 &&
                <button className="btn btn-primary btn-sm table-text rounded px-2 mr-2"
                    disabled={tableLoading}
                    onClick={()=> setLoadAll(!loadAll)}
                >
                    {loadAll ? "Load less" : "Load All"}
                </button>
                }
                {data && data?.length > 0 && (
                    <button
                    className="btn btn-primary text-uppercase btn-sm table-text px-2 rounded"
                    onClick={(e) => getReport(e)}
                    >
                        <i class="fa fa-table mr-1" aria-hidden="true"></i>
                        download 
                    </button>
                )
                }
                </div>
            </div>
            {data && dataHead?.length > 0 && (
                <div className="col-12 mt-2">
                    <div key={dataBody?.length} className="production-table-view rounded shadow-sm bg-white border" style={{height:"auto", maxHeight:"22.5rem", overflow:"auto"}}>
                    <table id={heading}  className="table table-hover fk-sm-card__title mb-1 table-borderless sticky-table-header">
                        {date.startDate && date.endDate && (
                            <tr className="d-none"> 
                            <th colSpan={dataHead?.length}>
                                <h3 className="text-center mt-0">
                                    {heading}
                                </h3>
                                <p className="text-center">
                                    FROM&nbsp;
                                    <Moment format="LL">
                                        {date.startDate}
                                    </Moment>
                                    &nbsp;TO&nbsp;
                                    <Moment format="LL">{date.endDate}</Moment>
                                </p>
                            </th>
                            </tr>
                        )}
                        {data && data?.length > 0 && (
                            <>
                                <thead className="bg-light sticky-top" style={{ zIndex: 1 }}>
                                    <tr>
                                    {dataHead?.length && dataHead.map((item,i)=>{
                                        return(
                                        <th
                                            key={i}
                                            scope="col"
                                            className="text-capitalize font-weight-bold py-3 px-4 border-0 text-center align-middle"
                                            style={{ color: "#2977c9", letterSpacing: "0.5px", whiteSpace: "nowrap", backgroundColor: "#f8fafd", borderBottom: "1px solid #e6ecf1" }}
                                        >
                                            {item}
                                            {item === "Total Payable" &&
                                            <TiArrowSortedUp className = "ml-1 cursor-pointer" style={{ fontSize: "18px" }} onClick={()=>{
                                                const sorting = [...dataBody].sort((a,b)=>{
                                                    return parseFloat(a[item]) - parseFloat(b[item]);
                                                });
                                                setTimeout(() => {
                                                    setDataBody(sorting);
                                                }, 200);
                                            }}/>
                                            }
                                        </th>
                                        )
                                    })
                                    }
                                    </tr>
                                </thead>
                                <tbody>
                                {dataBody?.length && dataBody?.map((dataChild, idx) => {
                                    return(
                                    <tr key={idx} className="border-bottom" style={{ transition: "all 0.2s" }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f4f6f8'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                    {dataHead.map((key,i) => {
                                        const value = dataChild[key];
                                        const isValidNumber = value !== null && value !== "" && value !== "-" && !isNaN(value);
                                        const table = isValidNumber ? Number(Number(value).toFixed(2)) : ((value === "-" || !value) ? "-" : value);
                                        return (
                                            <td 
                                                key={i}
                                                className={`text-capitalize border-0 py-3 px-2 align-middle text-center`}
                                                style={{ color: "#495057", whiteSpace: "nowrap" }}
                                            >
                                                {table}
                                            </td>
                                        );
                                    })}
                                    </tr>
                                    )
                                })}
                                </tbody>
                            </>
                        )}
                    </table>
                    </div>
                </div>
            )}
            </div> 
        </div>
    )
}

export default TableListDynamic